<div class="vh-100 d-flex flex-column bg-gray position-fixed top-0 start-0 w-100">
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0"
  ></Navbar>

  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar />
        </div>
      </div>

      <div class="col h-100 overflow-auto">
        <div class="container-fluid py-3 pb-extra px-2 px-sm-3 px-lg-4">

          <section v-if="!is_admin" class="card border shadow-sm rounded bg-light">
            <div class="card-body text-center p-5">
              <i class="bi bi-shield-lock text-muted display-6"></i>
              <h6 class="fw-bold text-dark mt-3 mb-1">Admin Access Required</h6>
              <p class="text-muted small mb-0">Only system admins can manage company promo codes.</p>
            </div>
          </section>

          <div v-else class="row g-3">
            <div class="col-12 col-xl-4">
              <section class="card border shadow-sm rounded bg-light h-100">
                <div class="card-body p-3 p-lg-4">
                  <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
                    <div>
                      <h6 class="fw-bold text-dark mb-1">Businesses</h6>
                      <p class="text-muted small mb-0">Choose the company that owns the promo.</p>
                    </div>
                    <span class="badge my-orders-tab-badge rounded-circle d-inline-flex align-items-center justify-content-center">{{ businesses.length }}</span>
                  </div>

                  <div class="input-group rounded bg-white border shadow-sm mb-3">
                    <span class="input-group-text bg-white border-0">
                      <i class="bi bi-search text-muted"></i>
                    </span>
                    <input
                      v-model="business_query"
                      type="text"
                      class="form-control border-0 shadow-none bg-white"
                      placeholder="Search businesses..."
                    />
                  </div>

                  <div v-if="is_loading_businesses" class="text-center p-5">
                    <div class="spinner-border text-primary" role="status"></div>
                    <p class="text-muted small mt-2 mb-0">Loading businesses...</p>
                  </div>

                  <div v-else-if="filtered_businesses.length" class="d-flex flex-column gap-2">
                    <button
                      v-for="business in filtered_businesses"
                      :key="get_business_base_profile_id(business)"
                      type="button"
                      class="btn text-start border rounded bg-white shadow-sm p-3"
                      :class="String(selected_business_id) === String(get_business_base_profile_id(business)) ? 'border-primary' : 'border-light'"
                      @click="select_business(business)"
                    >
                      <span class="d-flex align-items-start justify-content-between gap-2">
                        <span class="d-block overflow-hidden">
                          <span class="d-block fw-bold text-dark text-xs text-truncate">{{ business?.company_name || 'Company' }}</span>
                          <span class="d-block text-muted text-xxs text-truncate">{{ get_business_owner_name(business) }}</span>
                        </span>
                        <i
                          class="bi"
                          :class="String(selected_business_id) === String(get_business_base_profile_id(business)) ? 'bi-check-circle-fill text-primary' : 'bi-chevron-right text-muted'"
                        ></i>
                      </span>
                    </button>
                  </div>

                  <div v-else class="text-center p-5 bg-white rounded border">
                    <i class="bi bi-building text-muted display-6"></i>
                    <h6 class="fw-bold text-dark mt-3 mb-1">No Businesses Found</h6>
                    <p class="text-muted small mb-0">There are no companies to manage yet.</p>
                  </div>
                </div>
              </section>
            </div>

            <div class="col-12 col-xl-8">
              <section class="card border shadow-sm rounded bg-light h-100">
                <div class="card-body p-3 p-lg-4">
                  <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3 mb-3">
                    <div>
                      <h6 class="fw-bold text-dark mb-1">
                        {{ selected_business?.company_name || 'Company Products' }}
                      </h6>
                      <p class="text-muted small mb-0">Create promo codes for individual products, or use catalogue promo for all products.</p>
                    </div>

                    <button
                      v-if="selected_business"
                      type="button"
                      class="btn btn-sm btn-primary rounded px-3"
                      @click="view_business_profile(selected_business)"
                    >
                      View Profile
                    </button>
                  </div>

                  <div v-if="!selected_business" class="text-center p-5 bg-white rounded border">
                    <i class="bi bi-arrow-left-circle text-muted display-6"></i>
                    <h6 class="fw-bold text-dark mt-3 mb-1">Select A Business</h6>
                    <p class="text-muted small mb-0">Choose a company from the list to load its products.</p>
                  </div>

                  <template v-else>
                    <div class="row g-3 mb-3">
                      <div class="col-12 col-md-6">
                        <div class="card border shadow-sm rounded bg-white h-100">
                          <div class="card-body p-3">
                            <p class="text-muted text-uppercase small fw-semibold mb-1">Products</p>
                            <h5 class="fw-bold text-dark mb-0">{{ catalogue_products.length }}</h5>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="card border shadow-sm rounded bg-white h-100">
                          <div class="card-body p-3">
                            <p class="text-muted text-uppercase small fw-semibold mb-1">Business</p>
                            <h5 class="fw-bold text-dark mb-0 text-truncate">{{ selected_business.company_name }}</h5>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="input-group rounded bg-white border shadow-sm mb-3">
                      <span class="input-group-text bg-white border-0">
                        <i class="bi bi-search text-muted"></i>
                      </span>
                      <input
                        v-model="product_query"
                        type="text"
                        class="form-control border-0 shadow-none bg-white"
                        placeholder="Search products..."
                      />
                    </div>

                    <div v-if="is_loading_products" class="text-center p-5">
                      <div class="spinner-border text-primary" role="status"></div>
                      <p class="text-muted small mt-2 mb-0">Loading products...</p>
                    </div>

                    <div v-else-if="filtered_products.length" class="table-responsive">
                      <table class="table align-middle bg-white rounded overflow-hidden mb-0">
                        <thead class="table-light">
                          <tr>
                            <th class="text-muted small text-uppercase">Product</th>
                            <th class="text-muted small text-uppercase">Price</th>
                            <th class="text-muted small text-uppercase text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="product in filtered_products" :key="product.id">
                            <td>
                              <span class="fw-bold text-dark text-xs">{{ product.name }}</span>
                            </td>
                            <td class="text-xs fw-semibold text-dark">R{{ Number(product.price || 0).toLocaleString('en-ZA') }}</td>
                            <td class="text-end gap-2 d-flex justify-content-end">
                              <button
                                type="button"
                                class="btn btn-sm btn-primary rounded px-3"
                                @click="open_product_promo_code_manager(product)"
                              >
                                Promo Codes
                              </button>
                              <button
                                type="button"
                                class="btn btn-sm btn-primary rounded px-3"
                                @click="view_product_details(product)"
                              >
                                View Product
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-else class="text-center p-5 bg-white rounded border">
                      <i class="bi bi-box-seam text-muted display-6"></i>
                      <h6 class="fw-bold text-dark mt-3 mb-1">No Products Found</h6>
                      <p class="text-muted small mb-0">This company does not have products available for promo codes.</p>
                    </div>
                  </template>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ProductPromoCode
    ref="productPromoCodeRef"
    @promo-updated="handle_promo_update"
    @promo-deleted="handle_promo_update"
  />
</div>
